import React from 'react';
import './InputError.scss';

export default function InputError({error, children})
{
    return (
        <span className='input-error-container'>
            {error ? <span className='input-error'>{children||error}</span> : null}
        </span>
    )
}